// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { MY_ACCOUNT_SAVE_BIP_DETAILS } from './constants';

export function saveBipDetails(data) {
  return {
    type: MY_ACCOUNT_SAVE_BIP_DETAILS,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MY_ACCOUNT_SAVE_BIP_DETAILS:
      return {
        ...state,
        bipData: { ...state.bipData, ...action.data },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/my-account/redux/saveBipDetails.js